export default __webpack_public_path__ + "static/media/img-fest-virtual.32d5b402.png";